/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:90cee143-856c-4c34-ba3c-21a0e2646e18",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_Kuw880R10",
    "aws_user_pools_web_client_id": "7j7sbbrkor9nnb3rk8kmr6fjv3",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://mnux32ilynhpvmld4rfjtssitm.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "madamisu113932-madamidev",
    "aws_user_files_s3_bucket_region": "ap-northeast-1"
};


export default awsmobile;
